import { Col, Row, Statistic } from 'antd'
import React from 'react'
import { useEffect, useState } from 'react';

function Stats() {
    const [result, setResult] = useState({
        sumDogenano: 0,
        sumDogecoin: 0
    })
    const [xdgNanoPrice, setXdgNanoPrice] = useState(0)
    const [nanoPrice, setNanoPrice] = useState(0)

    useEffect(() => {
          
        fetch("https://data.nanswap.com/nano-price")
          .then((r) => r.json())
          .then(r => {
            setNanoPrice(r)
          })
        fetch("https://data.nanswap.com/get-markets")
          .then((r) => r.json())
          .then(r => {
            const xdgNanoMarket = r.find(m => m.key === "XDG/XNO")
            if(xdgNanoMarket) {
                setXdgNanoPrice(xdgNanoMarket.midPrice)
            }
          })
          
      }, [])

  return (
    <div >
    <Row gutter={{xs: 8, sm: 8}} >
        {/* <Col span={12}>
        <Statistic style={{backgroundColor: "white", borderRadius: 8, marginRight: "auto", marginLeft: "auto", padding: 8, marginBottom: 16}} suffix={"XDG"} value={result.sumDogenano} title={"DogeNano claimed"} precision={0}/>
        </Col>  */}
        <Col span={12} md={6}>
        <Statistic style={{width: "100%", backgroundColor: "white", borderRadius: 8, marginRight: "auto", marginLeft: "auto", padding: 8, marginBottom: 16}} suffix={"XDG"} value={10000000} title={"Circulating Supply"} precision={0}/>
        </Col>
        <Col span={12} md={6}>
        <Statistic style={{width: "100%", backgroundColor: "white", borderRadius: 8, marginRight: "auto", marginLeft: "auto", padding: 8, marginBottom: 16}} suffix={"XDG"} value={10000000} title={"Max Supply"} precision={0}/>
        </Col>
        <Col span={12} md={6}>
        <Statistic style={{width: "100%", backgroundColor: "white", borderRadius: 8, marginRight: "auto", marginLeft: "auto", padding: 8, marginBottom: 16}} suffix={"$"} value={xdgNanoPrice*nanoPrice} title={"Price"} precision={6}/>
        </Col>
        <Col span={12} md={6}>
        <Statistic style={{width: "100%", backgroundColor: "white", borderRadius: 8, marginRight: "auto", marginLeft: "auto", padding: 8, marginBottom: 16}} suffix={"$"} value={xdgNanoPrice*nanoPrice*10000000}
        title={"Market cap"} precision={0}/>
        </Col>
    </Row>

    </div>
  )
}

export default Stats
